/**
 * Params the OAuth callback appends to the funnel URL. They identify the
 * just-authenticated customer and must not travel further down the funnel —
 * everything else (utm_*, gclid, catalog_id, ct, cv, coupon ...) must, or the
 * next page loses its campaign attribution and its preselection.
 */
const OAUTH_CALLBACK_PARAMS = [
  "accessToken",
  "lastName",
  "firstName",
  "refreshToken",
  "language",
  "country",
  "email",
  "showOauthAdditionalInfoModal",
  "provider",
];

/** The current query string minus the OAuth callback params, safe to forward. */
export const getForwardableFunnelSearch = (searchParams: URLSearchParams): URLSearchParams => {
  const forwardable = new URLSearchParams(searchParams);
  OAUTH_CALLBACK_PARAMS.forEach((param) => forwardable.delete(param));
  return forwardable;
};

/** Same, formatted for `navigate({ search })` — "" when nothing is left to carry. */
export const getForwardableFunnelSearchString = (searchParams: URLSearchParams): string => {
  const forwardable = getForwardableFunnelSearch(searchParams).toString();
  return forwardable ? `?${forwardable}` : "";
};
